import { jsx as r, Fragment as t } from "@emotion/react/jsx-runtime";
import { memo as e } from "react";
const i = e(({
  actions: m
}) => /* @__PURE__ */ r(t, { children: m?.map((o) => o) }));
i.displayName = "Actions";
export {
  i as Actions
};
